

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetWallet extends Vue {
  @Prop({ default: '36' }) readonly width?: string;
  @Prop({ default: '38' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
